import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import AuthCodeInput from '../../components/Form/AuthCodeInput';

import styles from './styles';
import userService from '../../services/userService';
import { useRoute } from '@react-navigation/core';
import toast from '../../utils/toast';
import AsyncStorage from '@react-native-async-storage/async-storage';

const NewPassword = ({ navigation }) => {

    const route = useRoute();

    const [password, setPassword] = useState('');

    const [currentPassword, setCurrentPassword] = useState(route.params?.password);

    useEffect(() => {
        resetPassword();
    }, [password])

    const resetPassword = async () => {
        if (password.length === 6) {
            const token = await AsyncStorage.getItem('JWT_TOKEN');
            userService.changePassword(token, currentPassword, password).then((response) => {
                if (response.status == 200) {
                    toast(response.data.message, 'green');
                    navigation.navigate('MyAccount');
                } else {
                    handleError(response.data);
                }
            }).catch((error) => {
                handleError(error?.response?.data);
            });
        }
    }

    const handleError = (data) => {
        if (data?.message) {
            toast(data.message, '#DA1414');
        } else {
            toast('Ocorreu um erro na atualização da senha', '#DA1414');
        }
    }

    return (
        <>
            <HeaderDefault title={'Nova senha'} />
            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite a sua nova senha "
                />
            </View>
        </>
    );
}

export default NewPassword;